var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, InfoCircleIcon, Link, Tooltip, TooltipTrigger, Typography, useTooltip, } from '@lucidlink/uicore';
import { getLucidlinkClassicConfig } from './LucidlinkClassicLink.constants';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-17591
export const LucidlinkClassicLink = ({ hasInfoTooltip = true, location, }) => {
    _react_refresh_temp_2();
    const lucidlinkClassicConfig = getLucidlinkClassicConfig();
    const { isTooltipActive, tooltipProps, triggerProps } = useTooltip({
        placement: 'top',
    });
    return (_jsxs(Box, { align: "center", gap: "sm", orientation: "vertical", children: [_jsx(Typography, { "data-testid": "lucidlink-classic-title", kind: "generic", children: lucidlinkClassicConfig[location].title }), _jsxs(Box, { align: "center", gap: "xs", children: [_jsx(Link, { "data-testid": "lucidlink-classic-link", kind: "subtle", target: "_blank", to: lucidlinkClassicConfig[location].linkTo, children: lucidlinkClassicConfig[location].linkText }), hasInfoTooltip && (_jsx(TooltipTrigger, { triggerProps: triggerProps, children: _jsx(InfoCircleIcon, { size: "small" }) })), hasInfoTooltip && location === 'login' && isTooltipActive && (_jsx(Tooltip, { contents: [
                            lucidlinkClassicConfig[location].tooltipText,
                        ], tooltipProps: tooltipProps }))] })] }));
};
_react_refresh_temp_1 = LucidlinkClassicLink;
$RefreshReg$(_react_refresh_temp_1, "LucidlinkClassicLink");
_react_refresh_temp_2(LucidlinkClassicLink, "6Z9hKiQbkXe/L4MlJ1mOoLfPqrI=", false, () => [useTooltip]);
